import {
  GetCustomers,
  GetCustomer,
  UpdateCustomer,
  UpdateCustomerMailbox,
  UpdateCustomerPhotoIdExpiration,
  CreateCustomer,
  CreateCustomerLvl1,
  ExportCustomersCSV,
  ImportCustomersCSV,
  AuthenticateCustomer,
  GetRoles,
  SetCustomerRole,
  GetOfficerndMembers,
  ConnectOfficerndMember,
  DisconnectOfficerndMember,
  GetDeskworksMembers,
  ConnectDeskworksMember,
  DisconnectDeskworksMember,
  GetQuickbooksMembers,
  ConnectQuickbooksMember,
  DisconnectQuickbooksMember,
  GetNexudusMembers,
  ConnectNexudusMember,
  DisconnectNexudusMember,
  EnableCustomer,
  CancelScheduledActivation,
  DisableCustomer,
  DeleteCustomer,
  CancelScheduledCancelation,
  GetCustomerActivities,
  SaveAccountDocument,
  SetCustomerCoupon,
  RemoveCustomerCoupon,
  SetCustomerTrial,
  RemoveCustomerTrial,
  CreateCustomerCharge,
  CreateCustomCharge,
  DeleteCustomCharge,
  CreateCustomInvoice,
  DeleteInvoice,
  GetLiveRecipients,
  AddLiveRecipient,
  UpdateLiveRecipient,
  DeleteLiveRecipient,
  DestroyAccountDocument,
  CancelSchedulingSwitchPlan
} from "@/api/customers";

// eslint-disable-next-line import/no-cycle

export const getCustomers = ({ dispatch, commit }, data) =>
  dispatch("CheckAuth", null, { root: true })
    .then(() =>
      GetCustomers(data.query).then(res => {
        if (!data.isMore) commit("SAVE_CUSTOMERS_LIST", res.customers);
        else commit("SAVE_MORE_CUSTOMERS", res.customers);

        commit("SAVE_CUSTOMERS_TOTAL", res.total_count);
        return res;
      })
    )
    .catch(e => console.log("Error on getCustomers", e));

export const getCustomer = ({ dispatch, commit }, id) =>
  dispatch("CheckAuth", null, { root: true })
    .then(() =>
      GetCustomer(id).then(res => {
        commit("SET_CURRENT_CUSTOMER", res.customer);
        return res.customer;
      })
    )
    .catch(e => console.log("Error on getCustomers", e));

export const setCurrentCustomer = ({ dispatch, commit }, customer) =>
  dispatch("CheckAuth", null, { root: true }).then(() => {
    commit("SET_CURRENT_CUSTOMER", customer);
  });

export const updateCustomer = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    UpdateCustomer(data)
      .then(res => {
        commit("SET_CURRENT_CUSTOMER", res.customer);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const updateCustomerPMB = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    UpdateCustomerMailbox(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const updateCustomerPhotoIdExpiresAt = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    UpdateCustomerPhotoIdExpiration(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createCustomer = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", true, { root: true }).then(() =>
    CreateCustomer(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createCustomerLvl1 = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateCustomerLvl1(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const exportCustomers = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ExportCustomersCSV(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const importCustomers = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ImportCustomersCSV(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const authCustomer = ({ dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    AuthenticateCustomer(id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getAllowedRoles = ({ dispatch }) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetRoles()
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const setCustomerRole = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    SetCustomerRole(data)
      .then(res => {
        commit("SET_CURRENT_CUSTOMER_ROLE", res.customer.role);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const enableCustomer = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    EnableCustomer(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const cancelScheduledActivation = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CancelScheduledActivation(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const disableCustomer = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DisableCustomer(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

  export const cancelScheduledCancelation = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
  CancelScheduledCancelation(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const cancelSchedulingSwitchPlan = ({ commit, dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CancelSchedulingSwitchPlan(id)
      .then(res => {
        return res;
      }).catch(e => new Promise((resolve, reject) => {
          reject(e);
      })))


export const deleteCustomer = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DeleteCustomer(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getCustomerEvents = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetCustomerActivities(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const saveAccountDocument = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    SaveAccountDocument(data)
      .then(res => {
        commit("SAVE_CURRENT_CUSTOMER_DOCUMENT", res.account_document);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const destroyAccountDocument = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DestroyAccountDocument(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const setCustomerCoupon = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    SetCustomerCoupon(data)
      .then(res => {
        console.log(res);
        commit("SET_CURRENT_CUSTOMER_COUPON", data);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const removeCustomerCoupon = ({ commit, dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    RemoveCustomerCoupon(id)
      .then(res => {
        commit("SET_CURRENT_CUSTOMER_COUPON", {
          coupon_id: null,
          coupon_code: null
        });
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const setCustomerTrial = ({ commit, dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    SetCustomerTrial(data)
      .then(res => {
        commit("SET_CURRENT_CUSTOMER_TRIAL", data.date);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const removeCustomerTrial = ({ commit, dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    RemoveCustomerTrial(id)
      .then(res => {
        commit("SET_CURRENT_CUSTOMER_TRIAL", null);
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createCustomerCharge = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateCustomerCharge(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createCustomCharge = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateCustomCharge(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const deleteCustomCharge = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DeleteCustomCharge(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const createCustomInvoice = ({ dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    CreateCustomInvoice(id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const deleteInvoice = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DeleteInvoice(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getLiveRecipients = ({ dispatch }) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetLiveRecipients()
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const addLiveRecipient = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    AddLiveRecipient(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const updateLiveRecipient = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    UpdateLiveRecipient(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const deleteLiveRecipient = ({ dispatch }, id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DeleteLiveRecipient(id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getOfficerndMembers = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetOfficerndMembers(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const connectOfficerndMember = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ConnectOfficerndMember(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const disconnectOfficerndMember = ({ dispatch }, customer_id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DisconnectOfficerndMember(customer_id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getDeskworksMembers = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetDeskworksMembers(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const connectDeskworksMember = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ConnectDeskworksMember(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const disconnectDeskworksMember = ({ dispatch }, customer_id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DisconnectDeskworksMember(customer_id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getQuickbooksMembers = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetQuickbooksMembers(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const connectQuickbooksMember = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ConnectQuickbooksMember(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const disconnectQuickbooksMember = ({ dispatch }, customer_id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DisconnectQuickbooksMember(customer_id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const getNexudusMembers = ({ dispatch }, data) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    GetNexudusMembers(data)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const connectNexudusMember = ({ dispatch }, params) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    ConnectNexudusMember(params)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );

export const disconnectNexudusMember = ({ dispatch }, customer_id) =>
  dispatch("CheckAuth", null, { root: true }).then(() =>
    DisconnectNexudusMember(customer_id)
      .then(res => {
        return res;
      })
      .catch(
        e =>
          new Promise((resolve, reject) => {
            reject(e);
          })
      )
  );
